import { Action, LayoutState } from 'shared/interface';
import * as actionTypes from 'shared/store/action-types';

const initialState: LayoutState = {
	liveEvents: [],
	count: 0,
	isLiveChatVisible: 'minimized',
};

export const LayoutReducer = (state: LayoutState = initialState, action: Action): LayoutState => {
	switch (action.type) {
		case actionTypes.SET_LIVE_EVENT:
			return {
				...state,
				liveEvents: action.payload.liveEvents,
				count: action.payload.count,
			};
		case actionTypes.LIVE_CHAT:
			return {
				...state,
				isLiveChatVisible: action.payload,
			};
		default:
			return state;
	}
};
